import styled from 'styled-components';
import { donedealBreakpoints } from 'styled-system';

export const CloseIcon = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  border: 0;
  width: 16px;
  height: 16px;
  line-height: 1;
  vertical-align: middle;
  cursor: pointer;
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};

  & svg {
    width: 100%;
    height: 100%;
  }

  // Touch target
  &:before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${({ theme }) => theme.spacing.L40};
    height: ${({ theme }) => theme.spacing.L40};
    transform: translate(-50%, -50%);
    content: '';

    ${donedealBreakpoints.media.medium} {
      width: ${({ theme }) => theme.spacing.M24};
      height: ${({ theme }) => theme.spacing.M24};
    }
  }

  &:focus {
    outline: none;
    color: ${({ theme }) => theme.donedeal.colors.BLUE};
  }
`;

export const ListContainer = styled.div<{
  expanded: boolean;
  maxHeight: string;
}>`
  display: ${({ expanded }) => (expanded ? 'block' : 'none')};
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-y: auto;
  background: ${({ theme }) => theme.donedeal.colors.WHITE};
  border-radius: ${({ theme }) =>
    `0 0 ${theme.borderRadius.default} ${theme.borderRadius.default}`};
  z-index: ${({ theme }) => theme.donedeal.zIndices.DROPDOWN};
  box-shadow: ${({ theme }) => theme.shadow.CONTAINER};
  max-width: 100%;
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-column-gap: ${({ theme }) => theme.spacing.S8};
  align-items: center;
  background-color: ${({ theme }) => theme.donedeal.colors.WHITE};
  height: 48px;
  border-radius: ${({ theme }) => theme.donedeal.borderRadius.default};
  border: 1px solid ${({ theme }) => theme.donedeal.colors.GREY};
  padding: 0 ${({ theme }) => theme.donedeal.spacing.M16};

  &:focus-within {
    border-width: 2px;
    border-color: ${({ theme }) => theme.donedeal.colors.BLUE};
  }
`;

export const SearchIcon = styled.div`
  padding: 0;
  margin: 0;
  border: 0;
  width: 20px;
  height: 20px;
  font-size: 100%;
  line-height: 1;
  vertical-align: middle;

  svg {
    color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: none;
  }
`;

export const SInput = styled.input`
  outline: none;
  border: 0px;
  padding: 0px;
  background-color: transparent;
  ${({ theme }) => theme.donedeal.fontSize.M16};

  ${donedealBreakpoints.media.large} {
    ${({ theme }) => theme.donedeal.fontSize.M16}
  }
`;
